module.exports = __webpack_public_path__ + "static/media/s_skeleton.3e2ba6e0.mp3";